import { useTranslation } from 'react-i18next'

/* ─── Invoke Activity: endpoints by frequency ───

   A horizontal bar per endpoint, widest first. Prototype `.ep-row`
   (agent-studio.html:5437-5446). The label is the operation's
   "Category > Description" and the title attribute keeps the raw endpoint id
   reachable, since that is the value being counted.

   `max` is passed in rather than derived from `rows`, because the endpoint search
   is applied **after** aggregation (MS-702): the bars keep their true counts and
   only the rows shown are narrowed, so scaling to the filtered maximum would make
   a search silently rescale the chart. */

export interface BarRow {
  key: string
  label: string
  value: number
}

export function HorizontalBars({ rows, max }: { rows: BarRow[]; max: number }) {
  const { t } = useTranslation()
  const scale = Math.max(max, 1)
  return (
    <div>
      {rows.map(row => (
        <div key={row.key} className="ep-row">
          <div className="ep-label" title={row.key}>
            {row.label}
          </div>
          <div
            className="ep-track"
            role="img"
            aria-label={t('mcpAnalytics.detail.invoke.barAria', {
              label: row.label,
              count: row.value,
            })}
          >
            <div className="ep-fill" style={{ width: `${Math.round((row.value / scale) * 100)}%` }} />
          </div>
          <div className="ep-val">{row.value}</div>
        </div>
      ))}
    </div>
  )
}
